import { CONNECTION_TYPES, CONNECTOR_DISPLAY_NAME, } from '@thoughtspot/blink-constants';
export var TranslationKeys;
(function (TranslationKeys) {
    TranslationKeys["CSV_UPLOAD_PAGE_TITLE"] = "csvUpload.admin.page.title";
    TranslationKeys["CSV_UPLOAD_PAGE_DESCRIPTION"] = "csvUpload.admin.page.subtitle";
    TranslationKeys["CANCEL_CTA"] = "Cancel";
    TranslationKeys["EDIT_CTA"] = "EDIT";
    TranslationKeys["ENABLE_CTA"] = "status.Enable";
    TranslationKeys["SAVE_CHANGES_CTA"] = "csvUpload.admin.edit.cta";
    TranslationKeys["STATUS_ENABLED"] = "status.Enabled";
    TranslationKeys["STATUS_DISABLED"] = "status.Disabled";
    TranslationKeys["CSV_UPLOAD_DISCLAIMER"] = "csvUpload.admin.disclaimer";
    TranslationKeys["FAILURE_BANNER_MESSAGE"] = "alert.dataDeletionAlertMessages.cannotSave";
    TranslationKeys["SUCCESS_TOASTER_MESSAGE"] = "tscli.ui.datasave.success.message";
    TranslationKeys["LOADING_INDICATOR_MESSAGE"] = "tscli.ui.saveconfirmation.loading.message";
    TranslationKeys["CONFIRMATION_MODAL_TITLE"] = "csvUpload.confirmationModal.title";
    TranslationKeys["CSV_UPLOAD"] = "csvUpload.admin.leftPanel.title";
    TranslationKeys["SETTINGS_GET_FAILURE_MESSAGE"] = "tscli.ui.setting.get.failure.message";
})(TranslationKeys || (TranslationKeys = {}));
export var ModalActions;
(function (ModalActions) {
    ModalActions["CONFIRM"] = "CONFIRM";
    ModalActions["CANCEL"] = "CANCEL";
})(ModalActions || (ModalActions = {}));
export const featureName = 'csvUpload';
export const featureId = 'orion.embraceConfig.databasesWithCsvUploadEnabled';
export var tscliConfigOperationType;
(function (tscliConfigOperationType) {
    tscliConfigOperationType["ADD"] = "add";
    tscliConfigOperationType["RESET"] = "reset";
})(tscliConfigOperationType || (tscliConfigOperationType = {}));
export const SUPPORTED_CONNECTORS_FOR_CSV_UPLOAD = [
    CONNECTION_TYPES.RDBMS_SNOWFLAKE,
    CONNECTION_TYPES.RDBMS_DATABRICKS,
    CONNECTION_TYPES.RDBMS_GCP_BIGQUERY,
];
export const CSV_UPLOAD_CONNECTORS = SUPPORTED_CONNECTORS_FOR_CSV_UPLOAD.map(connectorType => ({
    id: connectorType,
    name: CONNECTOR_DISPLAY_NAME[connectorType],
    enabled: false,
}));
export const SCREEN_BLOCK_TIMEOUT = 90000;
export const CONTEXT = {
    ALL: { id: 'all-org', value: '-1', view_mode: 'all' },
    PRIMARY: { id: 'primary-org', value: '0', view_mode: 'primary' },
    NONE: { id: 'none-org', value: '', view_mode: '' },
};
//# sourceMappingURL=constants.js.map